export default class KliraCartCoupon {
    code = null;
    discountAmount = null;

    constructor(code, discountAmount = 0) {
        this.code = code.toLowerCase();
        this.discountAmount = discountAmount;
    }
}